import { render } from "./CreateVpnCustomerGateway.vue?vue&type=template&id=3e32331c&scoped=true"
import script from "./CreateVpnCustomerGateway.vue?vue&type=script&lang=js"
export * from "./CreateVpnCustomerGateway.vue?vue&type=script&lang=js"

import "./CreateVpnCustomerGateway.vue?vue&type=style&index=0&id=3e32331c&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e32331c"]])

export default __exports__